import PropTypes from 'prop-types';

const ConfirmationModal = (props) => {
    const {
        dialog,
        setDialog,
        onConfirm,
    } = props;
    return (
        <>
            {dialog && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-20 z-50">
                    <div className="bg-white rounded-lg shadow-lg sm:w-1/3 w-[280px]">
                        <div className="px-6 py-4 border-b">
                            <h3 className="text-lg font-semibold text-gray-800 poppins-medium">
                                Are you sure you want to delete the Indirizzo?
                            </h3>
                        </div>
                        <div className="px-6 py-4 flex justify-end space-x-4">
                            <button
                                onClick={onConfirm}
                                className="px-4 py-2 poppins-regular bg-[#8A2533] text-white rounded-md hover:bg-[#f6efef] hover:text-[#8A2533] transition-colors"
                            >
                                Yes
                            </button>
                            <button
                                onClick={() => setDialog(false)}
                                className="px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors"
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
ConfirmationModal.propTypes = {
    dialog: PropTypes.bool.isRequired,
    setDialog: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationModal;